// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCZhi3xzJuF5xjdDp3040GYusalmrwpH9g",
    authDomain: "padelmatch-6cb18.firebaseapp.com",
    projectId: "padelmatch-6cb18",
    storageBucket: "padelmatch-6cb18.firebasestorage.app",
    messagingSenderId: "420724449664",
    appId: "1:420724449664:web:f96241a96fa696c489e165",
    measurementId: "G-C60H69Y5PQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Safely obtain Analytics instance only when supported (HTTPS/localhost)
export async function getAnalyticsSafe() {
  try {
    const supported = await isSupported();
    if (!supported) return undefined;
    return getAnalytics(app);
  } catch {
    return undefined;
  }
}